import styled, { css } from "styled-components";

import { stylesGlobalDefault } from "../../global/globalStyle";
import { px } from "framer-motion";

interface IPropsContainer {
  width?: string;
  height?: string;
  marginRight?: string;
  withoutMarginBottom?: boolean;
}
interface IProps {
  error?: boolean;
  focus?: boolean;
  selected: boolean;
  disable: boolean;
  height?: string;
  showDefaultValue?: boolean;
}

export const DropDownContainer = styled("div")<IPropsContainer>`
  width: ${(props) => (props.width ? props.width : "380px")};
  margin-bottom: ${(props) => (props.withoutMarginBottom ? 0 : 22)}px;
  margin-right: ${(props) => props.marginRight && props.marginRight};
  cursor: pointer;
`;

export const Label = styled.span`
  font-family: ${stylesGlobalDefault.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  height: 17px;
  //color: #666;
  color: ${stylesGlobalDefault.gray};
  margin-bottom: 4.5px;
`;

export const DropDownHeader = styled.button.attrs({type: "button" })<IProps>`
  appearance: none;
  background: ${stylesGlobalDefault.white};
  border: ${(props) =>
    props.error
    ? `2px solid ${stylesGlobalDefault.inputsBorderFocusError}`
    : `2px solid ${stylesGlobalDefault.inputsBorderFocusOff}`};
  border-radius: 4px;
  padding: 12px 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8em;
  padding: 12px 16px;
  font-weight: 500;
  margin: 0;
  margin-top: 4.5px;
  font-size: 14px;
  color: ${(props) =>
    props.selected || props.showDefaultValue ? stylesGlobalDefault.black : stylesGlobalDefault.gray};
  background: ${stylesGlobalDefault.white};
  min-height: 24px;
  height: ${(props) => (props.height ? props.height : "auto")};

  cursor: pointer;
  cursor: ${(props) => (props.disable ? "not-allowed" : "pointer")};

  ${(props) =>
    props.focus &&
    css`
      border: 2px solid ${stylesGlobalDefault.blue};
    `}
  
  span {
    font-family: ${stylesGlobalDefault.fontFamily};
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const DropDownListContainer = styled("div")`
  min-width: 36%;
  width: 100%;
  position: relative;
  user-select: none;
`;

export const DropDownList = styled("ul")<IPropsContainer>`
  padding: 0;
  margin: 0;
  width: ${(props) => (props.width ? props.width : "380px")};
  max-height: 200px;
  background: ${stylesGlobalDefault.white};
  border: 2px solid ${stylesGlobalDefault.grayLight};
  box-sizing: border-box;
  color: #7887a9;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  z-index: 99;

  overflow-y: auto;
  /* width */
  ::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #1d9bf0;
    border-radius: 2px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  position: absolute;
  transform: translateY(0px);
  //max-height: 160px;
`;

interface ItemProps {
  selected: boolean;
}

export const ListItem = styled("li")<ItemProps>`
  list-style: none;
  padding: 10px;
  font-family: ${stylesGlobalDefault.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${stylesGlobalDefault.black};
  display: flex;
  justify-content: space-between;
  background-color: ${(props) =>
    props.selected ? "#e4f1fa" : stylesGlobalDefault.white};

  &:hover {
    background: #e4f1fa;
  }
  
  &:focus-visible {
    outline: none;
    background: #e4f1fa;
  }
`;
